module.exports = __webpack_public_path__ + "static/media/3_reshenie_na_SD_svikvane_20170631.2922136f.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/files/informationInversors/2017/3_reshenie_na_SD_svikvane_20170631.pdf
// module id = 152
// module chunks = 0